import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { Plus, Barbell, MapPin, ArrowRight } from "@phosphor-icons/react";
import { PageHeader } from "../ui/kaizen";

const LEVELS = [["provincial","Provincial"],["national","National"],["international","International"],["intercontinental","Intercontinental"],["mondial","Mondial"]];

export default function AthletesPanel() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ full_name:"", sport:"", level:"provincial", club:"", phone:"", email:"", birth_date:"", photo_url:"", notes:"" });

  const load = () => api.get("/athletes").then(r => setList(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try {
      const payload = { ...form };
      if (!payload.birth_date) delete payload.birth_date;
      if (!payload.photo_url) delete payload.photo_url;
      await api.post("/athletes", payload);
      setForm({ full_name:"", sport:"", level:"provincial", club:"", phone:"", email:"", birth_date:"", photo_url:"", notes:"" });
      setOpen(false); load();
      toast.success("Athlète ajouté");
    } catch { toast.error("Erreur"); }
  };

  return (
    <div data-testid="athletes-page">
      <div className="px-8 lg:px-12 pt-8">
        <PageHeader
          title="Circuit Athlètes"
          breadcrumbs={[{ label: "Compétition & événements" }, { label: "Athlètes" }]}
          subtitle="Carnet santé, blessures, performances. De la relève québécoise à la scène mondiale."
          actions={
            <button data-testid="add-athlete-btn" onClick={()=>setOpen(!open)} className="bg-[#D90429] hover:bg-[#BF0424] text-white px-5 py-2.5 rounded-lg text-sm font-semibold flex items-center gap-2 transition-colors">
              <Plus size={16}/> {open?"Annuler":"Ajouter"}
            </button>
          }
        />
      </div>

      {open && (
        <form onSubmit={add} className="hard-border-b px-8 lg:px-12 py-6 grid grid-cols-1 md:grid-cols-3 gap-3 bg-secondary/30" data-testid="add-athlete-form">
          <input data-testid="ath-name" required placeholder="Nom complet *" value={form.full_name} onChange={(e)=>setForm({...form, full_name:e.target.value})} className="hard-border px-3 py-2"/>
          <input data-testid="ath-sport" required placeholder="Discipline (Kickboxing / K-1 / Muay Thaï)" value={form.sport} onChange={(e)=>setForm({...form, sport:e.target.value})} className="hard-border px-3 py-2"/>
          <select data-testid="ath-level" value={form.level} onChange={(e)=>setForm({...form, level:e.target.value})} className="hard-border px-3 py-2 bg-white">
            {LEVELS.map(([v,l]) => <option key={v} value={v}>{l}</option>)}
          </select>
          <input data-testid="ath-club" placeholder="Club" value={form.club} onChange={(e)=>setForm({...form, club:e.target.value})} className="hard-border px-3 py-2"/>
          <input data-testid="ath-birth" type="date" value={form.birth_date} onChange={(e)=>setForm({...form, birth_date:e.target.value})} className="hard-border px-3 py-2"/>
          <input data-testid="ath-email" type="email" placeholder="Courriel" value={form.email} onChange={(e)=>setForm({...form, email:e.target.value})} className="hard-border px-3 py-2"/>
          <input data-testid="ath-phone" placeholder="Téléphone" value={form.phone} onChange={(e)=>setForm({...form, phone:e.target.value})} className="hard-border px-3 py-2"/>
          <input data-testid="ath-photo" placeholder="URL photo (optionnel)" value={form.photo_url} onChange={(e)=>setForm({...form, photo_url:e.target.value})} className="hard-border px-3 py-2 md:col-span-2"/>
          <textarea data-testid="ath-notes" placeholder="Notes" value={form.notes} onChange={(e)=>setForm({...form, notes:e.target.value})} className="hard-border px-3 py-2 md:col-span-3" rows={2}/>
          <button data-testid="ath-submit" className="bg-foreground hover:bg-[#D90429] text-white py-2.5 ticker transition-colors md:col-span-3">Créer l'athlète</button>
        </form>
      )}

      <div className="px-8 lg:px-12 py-8">
        {list.length === 0 ? (
          <div className="hard-border p-12 text-center">
            <Barbell size={48} weight="duotone" className="mx-auto text-muted-foreground mb-4"/>
            <div className="font-display text-xl font-bold">Aucun athlète</div>
            <div className="text-sm text-muted-foreground mt-1">Commence à bâtir la relève québécoise — Kickboxing, K-1, Muay Thaï.</div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0 hard-border">
            {list.map((a, i) => (
              <Link key={a.id} to={`/app/athletes/${a.id}`} data-testid={`athlete-card-${i}`}
                className={`p-6 group hover:bg-secondary/40 transition-colors ${i % 3 !== 2 ? 'md:border-r border-border' : ''} border-b border-border`}>
                <div className="flex items-start gap-4">
                  {a.photo_url ? (
                    <img src={a.photo_url} alt={a.full_name} className="w-14 h-14 object-cover hard-border"/>
                  ) : (
                    <div className="w-14 h-14 bg-secondary hard-border flex items-center justify-center">
                      <Barbell size={22} className="text-muted-foreground"/>
                    </div>
                  )}
                  <div className="flex-1 min-w-0">
                    <div className="font-display font-bold text-lg truncate">{a.full_name}</div>
                    <div className="ticker text-muted-foreground">{a.sport} · {a.level}</div>
                    {a.club && <div className="text-xs text-muted-foreground mt-1 flex items-center gap-1"><MapPin size={12}/>{a.club}</div>}
                  </div>
                  <ArrowRight size={16} className="text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity"/>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
